//@ts-nocheck
//@ts-ignore
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
import ClientPages from "@tuteria/shared-lib/src/client-pages/root";
import { OverlayRouter } from "@tuteria/shared-lib/src/components/OverlayRouter";
import { IRootStore } from "@tuteria/shared-lib/src/stores";
import { observer } from "@tuteria/shared-lib/src/mobx";
import "katex/dist/katex.min.css";
import "react-phone-input-2/lib/style.css";
import React from "react";

type Props = {
  page: string;
  initialData: any;
  store: IRootStore;
  saveTutorInfo: (data: any) => Promise<any>;
  [key: string]: any;
};
function App({ store, page, initialData, saveTutorInfo, ...rest }: Props) {
  return (
    <ThemeProvider>
      <OverlayRouter>
        <ClientPages
          page={page}
          store={store}
          initialData={initialData}
          saveTutorInfo={(payload) => saveTutorInfo({ data: payload })}
          {...rest}
        />
      </OverlayRouter>
    </ThemeProvider>
  );
}
export default observer(App);
